import { __decorate, __metadata } from "tslib";
import { BaseMessage, Field } from '@cbbt/lib-interface';
export class UpdateCaseRefNumber extends BaseMessage {
    caseRefNumber;
    individualId;
    owner;
}
__decorate([
    Field.string({
        required: true,
        description: 'Case Ref Number',
    }),
    __metadata("design:type", String)
], UpdateCaseRefNumber.prototype, "caseRefNumber", void 0);
__decorate([
    Field.string({
        required: true,
        description: 'individualId',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], UpdateCaseRefNumber.prototype, "individualId", void 0);
__decorate([
    Field.string({
        required: false,
        description: 'User ID',
        format: 'uuid',
    }),
    __metadata("design:type", String)
], UpdateCaseRefNumber.prototype, "owner", void 0);
//# sourceMappingURL=UpdateCaseRefNumber.js.map